import MaterialSnackbar from '@mui/material/Snackbar';
import { useSnackbar } from './SnackbarContext';

export const Snackbar = () => {
  const { snackbar, hideSnackbar } = useSnackbar();

  return (
    <MaterialSnackbar
      autoHideDuration={snackbar.autoHideDuration ?? 2000}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center',
      }}
      onClose={hideSnackbar}
      open={snackbar.open}
      message={snackbar.message}
    />
  );
};

export default Snackbar;
